module.exports = "<div class=calendar-grid> {{#each dayList}} <div class=date-gird> {{#if this.isPartOfMonth}} {{#if this.isToday}} <span class=today-span data-id={{this.dataTime}}>{{this.dayNum}}</span> {{else}} <span data-id={{this.dataTime}}>{{this.dayNum}}</span> {{/if}} {{#if this.isHaveRemind}} <i class=circle></i> {{/if}} {{else}} <span class=not-span>{{this.dayNum}}</span> {{/if}} </div> {{/each}} </div>";


//////////////////
// WEBPACK FOOTER
// ./app/components/bisystem/canvas/main/cells/cell/calendar/calendar.small/calendar.small.day/calendar.small.day.html
// module id = 4919
// module chunks = 50